
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import CatalogoResponse from "../../models/CatalogoResponse"; 
import OpcionRespuestaPregunta from "@/models/RegistroSobrevivencia/OpcionRespuestaPregunta";
import Presolicitud from "../../models/Presolicitud";
import VeeValidateForm from "@/vee-validate/types/VeeValidateForm";
import Inputmask from "inputmask";
import PreguntaFormulario from "@/models/Sobrevivencia/Pregunta";
import FormularioRespuesta from "@/models/Sobrevivencia/Formulario/FormularioRespuesta";
import Pregunta from "@/models/RegistroSobrevivencia/Pregunta";
import { Getter } from "vuex-class";
import SobrevivenciaService from "@/services/SobrevivenciaService";
import UbigeoRequest from "@/models/Sobrevivencia/Formulario/UbigeoRequest";
Vue.directive("input-mask", {
  update: function(el: any, binding: any, vnode: any) {
    const mascara: string = vnode.data.attrs.mask;
    const im = new Inputmask(mascara);
    im.mask(el);
  },
}); 
@Component({name :'Question'})
export default class Question extends Vue {
  @Prop() Pregunta: PreguntaFormulario;
  show: boolean = true;
  public textInputValue:string="";
  public parentescos: Array<CatalogoResponse> = [];
  public Selected: PreguntaFormulario = new PreguntaFormulario(null);
  public sobrevivenciaService: SobrevivenciaService = new SobrevivenciaService(); 
  public ubigeoLoading : boolean = false;
  public textInputMask: string="";
  public desplegar:string="";
  @Getter("validateAllSobrevivencia") validateAllSobrevivencia: boolean;
  async created() {
    this.autoScroll();
    // await this.fillResponse();
  }
  async mounted() {
    // console.log("1 "+this.Pregunta.id)
    this.autoScroll();
    // console.log("2 "+this.Pregunta.id)
    await this.fillResponse();
    // console.log("3 "+this.Pregunta.id)
    //this.fillUbigeoSelect();
    // console.log("4"+this.Pregunta.id)
 
  }
   
  selected(value) { 
    // console.log("new value selected:")
    // console.log(value);
    this.Selected = value;
    this.Pregunta.responseValue = value.id?.toString(); 
    let nuevaRespuesta:FormularioRespuesta = new FormularioRespuesta()
    nuevaRespuesta.idPregunta = this.Pregunta.id;
    nuevaRespuesta.idReiterativo = value.idReiterativo;
    
    if(this.Pregunta.indRequiereCarga !=null && this.Pregunta.indRequiereCarga.length>0)
    {
      nuevaRespuesta.ResponseValue = value.codUbigeo.toString() 
      nuevaRespuesta.idReiterativo = this.Pregunta.idReiterativo;
    }else{
      nuevaRespuesta.ResponseValue = value.id.toString() 
    }
   this.$emit("Selected",nuevaRespuesta)
    // console.log("Selected emited",nuevaRespuesta)
    
  }
  async  fillResponse() {
    // console.log(this.Pregunta.id +"---------------" +this.Pregunta.type + this.Pregunta.responseValue)
    if (
      this.Pregunta.type == "SELECT" &&
       this.Pregunta.responseValue != null &&
      this.Pregunta.responseValue.length > 0
      && (this.Pregunta.indRequiereCarga == null|| this.Pregunta.indRequiereCarga == "N"  )
    ) {
      // console.log(this.Pregunta.id +"---------------1" )
      const found = this.Pregunta.children.find(
        (x) => x.id == Number(this.Pregunta.responseValue)
      );
      this.Selected = found;
    }else if(this.Pregunta.indRequiereCarga != null ){
      // console.log(this.Pregunta.id +"---------------2" )
      await this.getUbigeoByCodigo();
      if(this.Pregunta.responseValue == null){
        this.Selected = null;
      }
    } 
    else if(this.Pregunta.type== "LABEL"){
      // console.log(this.Pregunta.id +"---------------3" )
      this.Selected = this.Pregunta;
    }else if(this.Pregunta.type == "TEXT" &&
       this.Pregunta.responseValue != null ){
        //  console.log(this.Pregunta.id +"---------------4" )
        this.textInputValue = this.Pregunta.responseValue
        // console.log("4"+this.Pregunta.id)
     }else{
      // console.log(this.Pregunta.id +"---------------5" )
      this.Selected = null;
      // console.log("6"+this.Pregunta.id)
     }
  }

  public alertSelected(value:FormularioRespuesta){ 
    // console.log("Selected emmited for pregunta "+value.idPregunta+"value:"+value.ResponseValue)
    this.$emit("Selected",value)
  }
  @Watch('displaySideBar')
  public cambio(){
    // console.log("displaySobrevivencia Cambió")
  }
  @Watch("textInputValue")

  @Watch("validateAllSobrevivencia")
  get getInputRules() {

    this.textInputMask = '999-99999-999'
    let rules = "";
     
    if(this.validateAllSobrevivencia){
      if(this.Pregunta.indRequerido == "S" || this.Pregunta.required =="S"){
        rules = rules + "required|"
      }
    }else{

      if(this.Pregunta.required =="S"){
         rules = rules + "required|"
      } 
    }

    // if((this.Pregunta.indRequerido == "S" || this.Pregunta.required =="S") || this.textInputValue?.length > 0)
    if((true))
    {
    if(this.Pregunta.indValidar == "CEDULA"){
      rules = rules + "cedula|"
      this.textInputMask = ""
    }
     if(this.Pregunta.indValidar == "EMAIL"){
      rules = rules + "emailAFP|"
    }
     if(this.Pregunta.indValidar == "TELEFONO"){
      rules = rules + "telefono|"
      this.textInputMask = ""
    }
     if(this.Pregunta.indValidar == "FECHA"){
      rules = rules + "date|dateBeforeNow|februaryInvalidDay|"
      this.textInputMask = ""
    } 
    if(this.Pregunta.indValidar == "SOLOTEXTO"){
      rules = rules + "alphabeticOnly|"
      this.textInputMask = ""
    }
     
     if(this.Pregunta.minLongitud != null){
      rules = rules + "minimo-validation:"+String(Math.floor(this.Pregunta.minLongitud )+"|");
     }
     if(this.Pregunta.maxLongitud != null){
      rules = rules + "maximo-validation:"+String( Math.floor(this.Pregunta.maxLongitud)+"|");
     }
    if(this.Pregunta.dataType != null && this.Pregunta.dataType =="R"){
       rules = rules + "onlyNumbers|"
      this.textInputMask = ""
    }
    if(this.Pregunta.indValidar == null && this.Pregunta.type== "TEXT"){
      rules=rules+"noSpecialCharacters|"
    }
    }
    return rules;
  }

  public autoScroll() {
    var textarea = document.getElementById(this.Pregunta.id.toString());
    textarea.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "nearest",
    });
    
  }
  public textInputChanged(value){
    let nuevaRespuesta:FormularioRespuesta = new FormularioRespuesta() 
    this.textInputValue = this.textInputValue.replace(/_/g,"");
    this.textInputValue = this.textInputValue.replace(/-/g,"");
    this.textInputValue = this.textInputValue.replace(/[{()}]/g,""); 
    //  console.log("------|" + this.textInputValue +"|------e------") 
    nuevaRespuesta.idPregunta = this.Pregunta.id;
    nuevaRespuesta.ResponseValue = this.textInputValue;
    nuevaRespuesta.idReiterativo = this.Pregunta.idReiterativo; 
    this.$emit("Selected",nuevaRespuesta)
    // console.log("Selected emited ",nuevaRespuesta)
  }
  public onInputEvent() {
    this.textInputValue = this.textInputValue.replace(/\s/g, "");
}
  @Watch("Selected")
  public selectedWatch(newValue:PreguntaFormulario,oldValue:PreguntaFormulario){
    // console.log("selecte Old value:" +oldValue +oldValue.text+":" + oldValue.id )
     if(oldValue!=null &&   oldValue.id !==null && oldValue.id != 0){
       this.resetResponses(newValue,true,this.Pregunta);
     }
  }

  public resetResponses(newValue:PreguntaFormulario,isFistNode:boolean,preguntaToReset:PreguntaFormulario){
    preguntaToReset.children.forEach(item=>{
        
        let nuevaRespuesta:FormularioRespuesta = new FormularioRespuesta()
          nuevaRespuesta.idPregunta = item.id;
          nuevaRespuesta.ResponseValue = "";
          nuevaRespuesta.idReiterativo = item.idReiterativo; 
        if(isFistNode){
            if(item.id != Number(newValue.responseValue) ){
              // console.log("Primer Nodo id:"+nuevaRespuesta.idPregunta +"to response:"+nuevaRespuesta.ResponseValue)
              this.$emit("Selected",nuevaRespuesta)
          }
          if(item.children.length > 0){
            this.resetResponses(item,false,item);
          }
        }else if(!isFistNode){
          // console.log("Nodo id:"+nuevaRespuesta.idPregunta +"to response:"+nuevaRespuesta.ResponseValue)
          this.$emit("Selected",nuevaRespuesta)
           if(item.children.length>0){
             this.resetResponses(item,false,item);
           }
        }
    })
  }

  public async getUbigeo(query:string){
    this.ubigeoLoading = true;
    await this.sobrevivenciaService.getUbigeo(new UbigeoRequest("PortalBe","4021370012",44,this.Pregunta.indRequiereCarga,query))
    .then((response)=>{
       this.Pregunta.children = response.data.data.children;
       this.ubigeoLoading = false;
    })
  }

   public async getUbigeoByCodigo(){
    if(this.Pregunta.responseValue != null && this.Pregunta.responseValue.length>0){
      this.ubigeoLoading = true;
    await this.sobrevivenciaService.getUbigeoByCodigo(new UbigeoRequest("PortalBe","4021370012",44,this.Pregunta.indRequiereCarga,this.Pregunta.responseValue))
    .then((response)=>{
       //this.Pregunta.children = response.data.data.children;
       this.Selected = response.data.data.children[0];
      //  console.log(response)
       this.ubigeoLoading = false;
    })
    }
  }

  @Watch("textInputValue")
  public textInputValueWatch (){
    this.textInputChanged("");
  }

  get showNormalTextInput(){
    return (
      (this.Pregunta.indValidar == null ||this.Pregunta.indValidar?.length <= 0 ) ||
      (this.Pregunta.indValidar == "EMAIL") || (this.Pregunta.indValidar!= null && this.Pregunta.indValidar == "SOLOTEXTO")
    )
  }
  @Watch('Pregunta.children')
  public setDesplegar(item:PreguntaFormulario){
     
    if(item.desplegarCol =='1'){
      return "col-12"
    }else{
      // console.log("Selected cuando determinando desplegar:" + item.text);
      // console.log(this.Selected);
      if( item.children.length> 0   ){
        
        let selectedHasChilden = this.selectedHasChilden(item,item.responseValue)
        if(selectedHasChilden){
          return 'col-12'
        }
        return "col-6"

      }
      return "col-6"
    }
    return item.desplegarCol =='1'   ?'col-12':'col-6';
  }

public selectedHasChilden(  pregunta:PreguntaFormulario ,responseValue :string){
   const encontrada = pregunta.children.filter((x)=> x.id == Number(responseValue))
   if(encontrada && encontrada[0]?.children.length>0)
   {
    return true
    
   }
   return false;
}
  
 public fillUbigeoSelect(){
  if(this.Pregunta.indRequiereCarga != null && this.Pregunta.indRequiereCarga.length>0){
    this.getUbigeo("A")
  }
 }   
 pasteHandler(e){
  // console.log(e.clipboardData.getData('text'))
  this.textInputValue = e.clipboardData.getData('text');
 }
  
}
